import React from 'react';
import { Badge } from '../ui/badge';
import { Separator } from '../ui/separator';

const Stepper = ({ currentStep, onStepClick }) => {
  const steps = [
    { number: 1, title: 'Bilmodell' },
    { number: 2, title: 'Grafik och placering' },
    { number: 3, title: 'Antal bilar' }
  ];

  return (
    <div className="flex items-center gap-2">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <button 
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
            onClick={() => onStepClick(step.number)}
          >
            <Badge 
              variant={currentStep >= step.number ? "default" : "secondary"}
              className="rounded-full w-6 h-6 flex items-center justify-center p-0"
            >
              {step.number}
            </Badge>
            <span className={`text-sm font-medium ${currentStep >= step.number ? '' : 'text-muted-foreground'}`}>
              {step.title}
            </span>
          </button>

          {index < steps.length - 1 && (
            <Separator orientation="vertical" className="h-6 mx-2" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Stepper; 